import client from './client';

interface Country {
  id: string;
  name: string;
  timezones: string[];
  defaultCurrency?: string;
}

export interface CurrencyOption {
  code: string;
  name: string;
}

interface Timezone {
  name: string;
  utcOffsetStr: string;
}

export async function fetchCountries(): Promise<Country[]> {
  const res = await client.get('/meta/countries');
  return res.data.countries;
}

export async function fetchTimezones(): Promise<Timezone[]> {
  const res = await client.get('/meta/timezones');
  return res.data.timezones;
}

export async function fetchCurrencies(): Promise<CurrencyOption[]> {
  const res = await client.get('/meta/currencies');
  return res.data.currencies;
}
